import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { ConfigService } from 'src/app/services/config-service/config.service';
import { OptionModel } from 'src/app/models/railcar-display-options.model';
import { RailCar } from 'src/app/models/railcar.model';
import { HttpClient } from '@angular/common/http';
import { LoginService } from 'src/app/services/login-service/login.service';
import { MixpanelService } from '../../services/mixpanel-service/mixpanel.service';

@Component({
  selector: 'app-quick-view-card',
  templateUrl: './quick-view-card.component.html',
  styleUrls: ['./quick-view-card.component.scss'],
})
export class QuickViewCardComponent implements OnInit {
  @Input() carDetails: RailCar = {
    model_id: 0,
    model_desc: '',
    car_overview: '',
    gross_rail_load: '',
    capacity: 0,
    capacity_uom: '',
    gate_type: null,
    gate_size: null,
    hatch_cover: '',
    compartments: null,
    stencil_spec: null,
    insulation: null,
    coils: null,
    pressure: 0,
    country: '',
    state: '',
    count: 0,
    rate: 0,
    rate2: 0,
    file_name: '',
    age: 0,
    compliance_due: '',
  };
  @Input() displayedAttr: OptionModel[] = [];
  @Input() displayHead = true;
  @Input() displayClear = false;
  originalDisplayedAttr: OptionModel[] = [];

  @Input() blank = false;
  @Input() selectEnabled = true;
  @Input() showSelect = true;
  @Input() selected = false;

  @Output() cardToggled: EventEmitter<any> = new EventEmitter();
  @Output() openModelFn: EventEmitter<any> = new EventEmitter();
  @Output() ValidationFilter: EventEmitter<any> = new EventEmitter();
  showValidation = false;

  DUE_FOR_TERMINATION = 'Due For Termination';
  NEW_RAILCAR_BUILDS = 'New Railcar Builds';

  isDisplayingDialog = false;
  detailViewObj: any | undefined;

  _imageURL_: any = '';
  // imageAltText = `${ this.carDetails.name } example car`;
  fromNewBuilds = false;
  constructor(
    public configService: ConfigService,
    private httpClient: HttpClient,
    private loginService: LoginService,
    private mixpanelService: MixpanelService
  ) {}

  ngOnInit(): void {
    if (history.state && history.state.fromNewBuilds) {
      this.fromNewBuilds = true;
    } else if (localStorage.getItem('fromNewBuilds') === 'true') {
      this.fromNewBuilds = true;
    }
    if (this.carDetails.file_name) {
      this.getImage(this.carDetails.file_name);
    }
    this.originalDisplayedAttr = [...this.displayedAttr];
    console.log(this.originalDisplayedAttr);
    this.displayedAttr = this.displayedAttr.filter(
      (attr) => attr.title !== 'Status'
    );
    console.log(this.displayedAttr);
    console.log(this.carDetails);
  }

  truncateText(text: any, limit: number): string {
    return text?.length > limit ? text?.substring(0, limit) + '...' : text;
  }

  openModel(car: any): void {
    this.isDisplayingDialog = true;
    this.detailViewObj = car;
  }

  closeModel(): void {
    this.isDisplayingDialog = false;
    this.detailViewObj = undefined;
  }

  carSelected(selectedCar: RailCar): void {
    this.isDisplayingDialog = false;
    console.log('Selected Car:', selectedCar);
    this.toggleSelected();
  }

  getImage(fileName: any) {
    const token = this.loginService.getSessionToken();
    if (token === null) this.loginService.signout();

    const image$ = this.httpClient.post(
      `${this.configService.imagesURL}/${fileName}`,
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
        observe: 'response',
        responseType: 'blob',
      }
    );
    image$.subscribe({
      next: (img: any) => {
        const reader = new FileReader();
        reader.addEventListener(
          'load',
          () => {
            this._imageURL_ = reader.result;
          },
          false
        );

        if (img) {
          reader.readAsDataURL(img.body);
        }
      },
      error: (err) => {
        console.error(err);
      },
    });
  }

  checkConditionalDisplayAttr(displayedAttr: OptionModel) {
    if (!displayedAttr.displayWhen) return true;
    const { carAttributeName, value } = displayedAttr.displayWhen;
    return value.includes(this.carDetails[carAttributeName]);
  }

  toggleSelected(): void {
    if (!this.selectEnabled) {
      this.ValidationFilter.emit(this.showValidation);

      return;
    }
    this.cardToggled.emit({ car: this.carDetails, selected: !this.selected });
  }

  openModal(): void {
    const userEmail = localStorage.getItem('userEmail') || '';
    this.mixpanelService.track({
      id: userEmail,
      eventName: 'product_search_moreinfo_click',
      eventDisplayName: 'Product More Info (i)',
      kpi: 'User Engagement',
      trigger: 'On Button Click',
      eventDefinition: 'User clicks the more information item',
      propertyType: 'Event Property',
      propertyDefinition: 'Button Label',
    });
    this.openModelFn.emit(this.carDetails);
  }

  isNan(value: string | number) {
    return isNaN(value as number);
  }
}
